// src/admin/ProductCreate.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductForm from './ProductForm';

const ProductCreate = () => {
  const navigate = useNavigate();

  const handleProductSubmit = (createdProduct) => {
    console.log('Producto creado:', createdProduct);
    navigate('/admin/products'); // redirige después de guardar
  };

  return (
    <div className="w-full">
      <ProductForm
        onSubmit={handleProductSubmit}
        onCancel={() => navigate('/admin/products')}
      />
    </div>
  );
};

export default ProductCreate;
